@keyframes card-animation {
  0% {
    opacity: 0;
    transform: scale(0.9) translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.cardContent {
  width: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: var(--border-radius-sm);
  overflow: hidden;
  background-color: var(--colors-grays-white);
  border: 1px solid var(--colors-transparent-black-ten);
  will-change: transform;
  animation: card-animation cubic-bezier(0.25, 0.46, 0.45, 0.94) 200ms both;
}

.cardContent:hover {
  border-color: var(--colors-transparent-black-twenty);
}

.cardContent__focused {
  background-color: var(--colors-grays-ultralight);
  cursor: default;
}

.cardContent__focused:hover {
  border-color: var(--colors-transparent-black-ten);
}

.backButton {
  padding: 0px;
  width: 24px;
  height: 24px;
}

/* DEFAULT VIEW */
.count {
  border-radius: 50%;
}

.countNumber {
  line-height: 1.25rem;
}

/* CONFIRMATION VIEW */
.photoBox img {
  object-fit: cover;
}
